import { IConfigRegua } from "../../../../Interfaces/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaInterfaces";
import {
    AtualizarConfigReguaService,
    CadastrarConfigReguaService,
    DeletarConfigReguaService,
    EnviarSMSService,
    ListarConfigReguaService,
} from "../../../../Services/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaServices";

import { Controller } from "../../../Controller";

export async function ListarConfigReguaController() {
    return Controller(ListarConfigReguaService());
}

export async function CadastrarConfigReguaController(
    ConfigRegua: IConfigRegua
) {
    return Controller(CadastrarConfigReguaService(ConfigRegua));
}

export async function DeletarConfigReguaController(idConfigRegua: number) {
    return Controller(DeletarConfigReguaService(idConfigRegua));
}

export async function AtualizarConfigReguaController(
    ConfigRegua: IConfigRegua
) {
    return Controller(AtualizarConfigReguaService(ConfigRegua));
}

export async function EnviarSMSController(
    idCasoCobrancaReguaConfig: number,
    nrTelefone: string,
    dsMensagem: string
) {
    return Controller(
        EnviarSMSService(idCasoCobrancaReguaConfig, nrTelefone, dsMensagem)
    );
}
